module.exports = __webpack_public_path__ + "img/avatar0.512acd25.png";